import { render } from "./NewDocVersion.vue?vue&type=template&id=372f5cf6&scoped=true"
import script from "./NewDocVersion.vue?vue&type=script&lang=js"
export * from "./NewDocVersion.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./NewDocVersion.vue?vue&type=style&index=1&id=372f5cf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372f5cf6"]])

export default __exports__